// 颜色支持：红red、黄yellow、蓝blue

export const Action_Default = {
    USER_MANAGER: [],
    DEVICE_MANAGER: [
        { text: "ACTION.GOTO_DATA", act: "GOTO_DATA", ico: "fal fa-database", color: "blue" },
        { text: "ACTION.SHOW_LOG", act: "SHOW_LOG", ico: "fal fa-clipboard-list-check", color: "blue" },
        { text: "ACTION.SHOW_OBJECT", act: "SHOW_OBJECT", ico: "fal fa-cubes", color: "blue" },
        { text: "ACTION.UNBIND_DEVICE", act: "UNBIND_DEVICE", ico: "fal fa-server", isdel: true, color: "red" },
    ],
    DATA_MANAGER: [
        { text: "ACTION.GOTO_DEVICE", act: "GOTO_DEVICE", ico: "fal fa-server", color: "blue" },
        // { text: "ACTION.GET_API", act: "SHOW_API", ico: "fal fa-cloud-download", color: "blue" },
        { text: "ACTION.DELETE_DATA", act: "DELETE_DATA", ico: "fal fa-database", isdel: true, color: "red" },
    ],
    PRODEVICE_MANAGER: [
        { text: "ACTION.GOTO_DEVICE", act: "GOTO_DEVICE", ico: "fal fa-server", color: "blue" },
        { text: "ACTION.PUBLISH_PRODEVICE", act: "PUBLISH_PRODEVICE", ico: "fal fa-hand-holding-box", color: "blue" },
        { text: "ACTION.SHOW_KEY", act: "SHOW_KEY", ico: "fal fa-key", color: "blue" },
        { text: "ACTION.DELETE_PRODEVICE", act: "DELETE_PRODEVICE", ico: "fal fa-box-alt", isdel: true, color: "red" },
    ],
    FIRMWARE_MANAGER: [
        { text: "ACTION.DOWNLOAD_FIRMWARE", act: "DOWNLOAD_FIRMWARE", ico: "fal fa-arrow-alt-to-bottom", color: "blue" },
        { text: "ACTION.TEST_FIRMWARE", act: "TEST_FIRMWARE", ico: "fal fa-download", color: "blue" },
        { text: "ACTION.PUBLISH_FIRMWARE", act: "PUBLISH_FIRMWARE", ico: "fal fa-megaphone", color: "blue" },
        { text: "ACTION.DELETE_FIRMWARE", act: "DELETE_FIRMWARE", ico: "fal fa-microchip", isdel: true, color: "red" },
    ],
    USERKEYS_MANAGER: [
        { text: "ACTION.CHANGE_STATE", act: "CHANGE_STATE", ico: "fa fa-key", color: 'blue' },
        { text: "ACTION.DELETE_KEY", act: "DELETE_KEY", ico: "fal fa-trash", isdel: true, color: "red" }
    ],
    ORDER_MANAGER: [
        { text: "ORDER.PAY", act: "PAY_ORDER", ico: "fa fa-credit-card", color: 'blue' },
    ]
}

export const Action_Developer = {
    DEVICE_MANAGER: [
        { text: "ACTION.GOTO_DATA", act: "GOTO_DATA", ico: "fal fa-database", color: "blue" },
        { text: "ACTION.SHOW_LOG", act: "SHOW_LOG", ico: "fal fa-clipboard-list-check", color: "blue" },
        { text: "ACTION.SHOW_OBJECT", act: "SHOW_OBJECT", ico: "fal fa-cubes", color: "blue" },
        { text: "ACTION.UNBIND_DEVICE", act: "UNBIND_DEVICE", ico: "fal fa-server", isdel: true, color: "red" },
    ],
    DATA_MANAGER: [
        { text: "ACTION.GOTO_DEVICE", act: "GOTO_DEVICE", ico: "fal fa-server", color: "blue" },
        // { text: "ACTION.GET_API", act: "SHOW_API", ico: "fal fa-cloud-download", color: "blue" },
        { text: "ACTION.DELETE_DATA", act: "DELETE_DATA", ico: "fal fa-database", isdel: true, color: "red" },
    ],
    PRODEVICE_MANAGER: [
        { text: "ACTION.GOTO_DEVICE", act: "GOTO_DEVICE", ico: "fal fa-server", color: "blue" },
        { text: "ACTION.PUBLISH_PRODEVICE", act: "PUBLISH_PRODEVICE", ico: "fal fa-hand-holding-box", color: "blue" },
        { text: "ACTION.SHOW_KEY", act: "SHOW_KEY", ico: "fal fa-key", color: "blue" },
        { text: "ACTION.DELETE_PRODEVICE", act: "DELETE_PRODEVICE", ico: "fal fa-box-alt", isdel: true, color: "red" },
    ],
    FIRMWARE_MANAGER: [
        { text: "ACTION.DOWNLOAD_FIRMWARE", act: "DOWNLOAD_FIRMWARE", ico: "fal fa-arrow-alt-to-bottom", color: "blue" },
        { text: "ACTION.TEST_FIRMWARE", act: "TEST_FIRMWARE", ico: "fal fa-download", color: "blue" },
        { text: "ACTION.PUBLISH_FIRMWARE", act: "PUBLISH_FIRMWARE", ico: "fal fa-megaphone", color: "blue" },
        { text: "ACTION.DELETE_FIRMWARE", act: "DELETE_FIRMWARE", ico: "fal fa-microchip", isdel: true, color: "red" },
    ],
    USERKEYS_MANAGER: [
        { text: "ACTION.CHANGE_STATE", act: "CHANGE_STATE", ico: "fa fa-key", color: 'blue' },
        { text: "ACTION.DELETE_KEY", act: "DELETE_KEY", ico: "fal fa-trash", isdel: true, color: "red" }
    ],
    ORDER_MANAGER: [
        { text: "ORDER.PAY", act: "PAY_ORDER", ico: "fa fa-credit-card", color: 'blue' },
    ]
}

export const Action_Admin = {
    USER_MANAGER: [
        { text: "ACTION.GOTO_DEVICE", act: "GOTO_DEVICE", ico: "fal fa-server", color: "blue" },
        { text: "ACTION.CHANGE_PASSWORD", act: "CHANGE_PASSWORD", ico: "fal fa-key", color: "yellow" },
        { text: "ACTION.CHANGE_GROUP", act: "CHANGE_GROUP", ico: "fal fa-user-crown", color: "yellow" },
        { text: "ACTION.REVIEW_VENDER", act: "REVIEW_VENDER", ico: "fal fa-user-shield", color: "yellow" },
        { text: "ACTION.DELETE_USER", act: "DELETE_USER", ico: "fal fa-user-friends", isdel: true, color: "red" },
    ],
    DEVICE_MANAGER: [
        { text: "ACTION.GOTO_USER", act: "GOTO_USER", ico: "fal fa-user-friends", color: "blue" },
        { text: "ACTION.GOTO_DATA", act: "GOTO_DATA", ico: "fal fa-database", color: "blue" },
        { text: "ACTION.SHOW_LOG", act: "SHOW_LOG", ico: "fal fa-clipboard-list-check", color: "blue" },
        { text: "ACTION.SHOW_OBJECT", act: "SHOW_OBJECT", ico: "fal fa-ufo-beam", color: "blue" },
        { text: "ACTION.DELETE_DEVICE", act: "DELETE_DEVICE", ico: "fal fa-server", isdel: true, color: "red" }
    ],
    DATA_MANAGER: [
        { text: "ACTION.GOTO_USER", act: "GOTO_USER", ico: "fal fa-user-friends", color: "blue" },
        { text: "ACTION.GOTO_DEVICE", act: "GOTO_DEVICE", ico: "fal fa-server", color: "blue" },
        // { text: "ACTION.GET_API", act: "SHOW_API", ico: "fal fa-cloud-download", color: "blue" },
        { text: "ACTION.DELETE_DATA", act: "DELETE_DATA", ico: "fal fa-database", isdel: true, color: "red" }
    ],
    PRODEVICE_MANAGER: [
        { text: "ACTION.GOTO_DEVICE", act: "GOTO_DEVICE", ico: "fal fa-server", color: "blue" },
        { text: "ACTION.PUBLISH_PRODEVICE", act: "PUBLISH_PRODEVICE", ico: "fal fa-hand-holding-box", color: "blue" },
        { text: "ACTION.SHOW_KEY", act: "SHOW_KEY", ico: "fal fa-key", color: "blue" },
        { text: "ACTION.DELETE_PRODEVICE", act: "DELETE_PRODEVICE", ico: "fal fa-box-alt", isdel: true, color: "red" }
    ],
    FIRMWARE_MANAGER: [
        { text: "ACTION.DOWNLOAD_FIRMWARE", act: "DOWNLOAD_FIRMWARE", ico: "fal fa-arrow-alt-to-bottom", color: "blue" },
        { text: "ACTION.TEST_FIRMWARE", act: "TEST_FIRMWARE", ico: "fal fa-download", color: "blue" },
        { text: "ACTION.PUBLISH_FIRMWARE", act: "PUBLISH_FIRMWARE", ico: "fal fa-megaphone", color: "blue" },
        { text: "ACTION.DELETE_FIRMWARE", act: "DELETE_FIRMWARE", ico: "fal fa-microchip", isdel: true, color: "red" }
    ],
    FEEDBACK_MANAGER: [
        { text: "ACTION.GOTO_USER", act: "GOTO_USER", ico: "fal fa-user-friends", color: "blue" },
        { text: "ACTION.RESOLVE_FEEDBACK", act: "RESOLVE_FEEDBACK", ico: 'fal fa-check', color: "blue" },
        { text: "ACTION.DELETE_FEEDBACK", act: "DELETE_FEEDBACK", ico: 'fal fa-comments', isdel: true, color: "red" }
    ],
    MESSAGE_MANAGER: [
        { text: "ACTION.DELETE_MESSAGE", act: "DELETE_MESSAGE", ico: 'fal fa-envelope', isdel: true, color: "red" }
    ],
    REVIEW_MANAGER: [
        { text: "ACTION.REVIEW_PASS", act: "REVIEW_PASS", ico: 'fal fa-check', color: "yellow" },
        { text: "ACTION.REVIEW_REJECT", act: "REVIEW_REJECT", ico: 'fal fa-times', color: "blue" }
    ],
    ORDER_MANAGER: [
        { text: "ACTION.GOTO_USER", act: "GOTO_USER", ico: "fal fa-user-friends", color: "blue" },
        { text: "ORDER.PAY", act: "PAY_ORDER", ico: "fa fa-credit-card", color: 'blue' },
    ]
}